module.exports = __webpack_public_path__ + "resources/img/img_secureguard1_m.64daa4bb55d1348fda661ea0b633314b.png";